<template>
  <div class="my-order" ref="container" style="padding-top: 1rem;">
    <!--<navTitle title="我的积分订单" path="/user" color="#fff"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti
          ? $router.app._route.query.ti
          : 'My points order'
      "
      path="/user"
      color="#fff"
    ></navTitle>

    <!-- <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">订单信息</div>
          <div>
            累计订单:{{ orderData.order_count || 0 }} 总消费:{{
              orderData.sum_price || 0
            }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div> -->
    <!--{{orderList}}-->
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <!-- <span class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0" >拼团</span>
              <span class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckill_id > 0" >秒杀</span>
              <span class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargain_id > 0" >砍价</span> -->
            {{ order._add_time }}
          </div>
          <div class="font-color-red">{{ order._status._msg }}</div>
        </div>
        <div
          @click="
            $router.push({ path: '/order/integral/details/' + order.order_id })
          "
        >
          <div class="item-info acea-row row-between row-top">
            <div class="pictrue">
              <img
                :src="order.product_info.image"
                @click.stop="
                  $router.push({
                    path: '/integral/detail/' + order.product_info.id
                  })
                "
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ order.product_info.name }}
              </div>
              <div class="money">
                <template>
                  <div>
                    {{ order.paid_integral }}
                  </div>
                </template>
                <div>x{{ order.total_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          Poinsts:
          <template>
            <span class="money font-color-red">{{ order.total_integral }}</span>
          </template>
        </div>
        <div class="bottom acea-row row-right row-middle">
          <div
            class="bnt btn-gray"
            @click="
              $router.push({
                path: '/order/integral/details/' + order.order_id
              })
            "
          >
            View details
          </div>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>

    <!--提货单-->
    <div class="plan" v-if="showGoodsPlan">
      <div class="plan-banner">Receipt</div>
      <div class="plan-title">Goods Details</div>
      <div class="plan-goods">
        <div class="img">
          <img
            v-if="selectGoods.game_state == 2"
            :src="selectGoods.cartInfo[0].productInfo.up_image"
            alt=""
          />
          <img v-else :src="selectGoods.cartInfo[0].productInfo.image" alt="" />
        </div>
        <div class="goods-info">
          <p class="goods-title" v-if="selectGoods.game_state == 2">
            {{ selectGoods.cartInfo[0].productInfo.up_store_name }}
          </p>
          <p class="goods-title" v-else>
            {{ selectGoods.cartInfo[0].productInfo.store_name }}
          </p>
          <p>x{{ selectGoods.cartInfo[0].productInfo.sales }}</p>
        </div>
      </div>
      <div class="plan-title">Receiving information</div>
      <div class="plan-form">
        <div class="form-row">
          <div class="row-name">Name</div>
          <input class="row-input" v-model="goodsForm.real_name" type="text" />
        </div>
        <div class="form-row">
          <div class="row-name">Phone</div>
          <input class="row-input" v-model="goodsForm.user_phone" type="text" />
        </div>
        <div class="form-row">
          <div class="row-name">Address</div>
          <input
            class="row-input"
            v-model="goodsForm.user_address"
            type="text"
          />
        </div>
        <!--<div class="form-row">-->
        <!--<div class="row-name">备注</div>-->
        <!--<input class="row-input" v-model="goodsForm.text" type="text">-->
        <!--</div>-->
      </div>
      <div class="plan-footer">
        <div class="plan-btn plan--btn-cancel" @click="cancelPickUp">
          Pick up later
        </div>
        <div class="plan-btn plan--btn-submit" @click="submitPickUp">
          Confirm pick up
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
  </div>
</template>
<script>
import { integral_order_list } from "@api/integral";
import navTitle from "@components/navTitle";

import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";


const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 1,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      selectGoods: "",
      showGoodsPlan: false,
      goodsForm: {
        order_id: "",
        real_name: "",
        user_phone: "",
        user_address: ""
        // text:''
      },
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5"
    };
  },
  components: {
    Loading,
    Payment,
    navTitle
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 1;
        if (this.type !== type) {
          this.changeType(type);
        }
      }
    }
  },
  methods: {
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },

    takeOrder(order) {
      takeOrderHandle(order.order_id).finally(() => {
        this.reload();
      });
    },
    reload() {
      this.showGoodsPlan = false;
      this.goodsForm = {
        order_id: "",
        real_name: "",
        user_phone: "",
        user_address: ""
      };
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      integral_order_list({
        page,
        limit,
        type
      }).then(res => {
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    }
  },
  mounted() {
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.btn-red {
  border: 1px solid #da2d2d;
  color: #da2d2d;
}
.btn-blue {
  border: 1px solid #00c3f9;
  color: #00c3f9;
}
.btn-gray {
  border: 1px solid #999999;
  color: #999999;
}
.btn-yellow {
  border: 1px solid #fcbb01;
  color: #fcbb01;
}

/*提货单*/
.plan {
  width: 6rem;
  height: 8.5rem;
  background: #fff;
  position: fixed;
  z-index: 1000;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin: auto auto;
  border-radius: 0.3rem;
  overflow: hidden;
}
.plan-banner {
  width: 100%;
  height: 1rem;
  background: url("../../../assets/images/tihuo.png") no-repeat;
  background-size: 100% 100%;
  line-height: 1rem;
  text-align: center;
  color: #333;
}
.plan-title {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.plan-goods {
  width: 100%;
  display: flex;
  padding: 0rem 0.3rem 0.3rem 0.3rem;
  box-sizing: border-box;
  border-bottom: 1px dashed #eee;
}
.plan-goods .img {
  width: 1rem;
  height: 1rem;
  background: #7a7a7a;
}

.plan-goods .img img {
  width: 100%;
  height: 100%;
}
.plan-goods .goods-info {
  flex: 1;
  padding-left: 0.15rem;
  box-sizing: border-box;
}
.plan-goods .goods-info .goods-title {
  font-size: 9px;
  width: 100%;
  overflow: hidden;
  /*text-overflow: ellipsis;*/
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.plan-form {
  width: 100%;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.plan-form .form-row {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  display: flex;
  margin-bottom: 0.3rem;
}
.plan-form .form-row .row-name {
  width: 1rem;
  height: 0.6rem;
  color: #333;
}
.plan-form .form-row .row-input {
  flex: 1;
  height: 0.6rem;
  color: #333;
  border: 1px solid #eee;
  border-radius: 0.15rem;
  margin-left: 0.3rem;
  padding: 0.15rem;
}

.plan-footer {
  position: absolute;
  width: 100%;
  height: 1rem;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0.3rem 0rem 0.3rem;
  box-sizing: border-box;
}
.plan-btn {
  width: 2.4rem;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  border-radius: 0.25rem;
}
.plan--btn-cancel {
  background: #fff;
  color: #666;
  border: 1px solid #999;
}
.plan--btn-submit {
  background: #00c3f9;
  color: #fff;
  border: 1px solid #00c3f9;
}
</style>
